export default __webpack_public_path__ + "static/media/equipments.a7dcde05.svg";